<template>
  <div style="height: 100%;">
    <!--楼顶给排水-->
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;">
      <span
        style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span>水位监测</span>
    </div>
    <div style="overflow-y: auto; height: 84%;margin-top: 4%">
      <no-data style="margin-top: 20%;" v-if="data.length < 1"></no-data>
      <span :key="item.id" v-else v-for="(item,index) in data">
        <div style="margin-bottom: 4%;border: 1px solid rgba(41, 159, 251, 0.2);width: 90%;margin: 0px 0px 15px 20px;padding-top: 3%">
         <span style="font-weight: bold;font-size: 1rem;margin-left: 9%">{{ item.deviceMeasuringPointHistoryList[0].deviceName }}</span>
          <span style="font-weight: bold;font-size: 1rem;float: right;margin-right: 6%" :style="{color:item.status === 0 || item.status === 2 ? '#00D488':'#F95453'}">
            <div style="width: 6px;height: 6px;opacity: 1;border-radius: 10px;margin-bottom: 1%;
            display: inline-flex;" :style="item.status  === 0 || item.status === 2 ? 'background: rgba(0, 212, 136, 0.39)' : 'background:rgba(249, 84, 83, 0.39)'"></div>
            {{ item.status === 0 || item.status === 2 ? '通讯正常' : '通讯异常' }}</span>
          <el-row style="padding: 23px 0 10px 46px;">
<!--        <el-col :span="7" style="margin-top: -1%;margin-right: 13%">-->
          <el-col :span="7" style="margin-top: -1%">
          <img style="width: 55%" src="../../../assets/images/comprehensive/水位.png">
        </el-col>
        <el-col :span="10" style="position: relative">
         <span style="position: absolute;top: 13px;left:-22px;font-size: 1px;color: #FFFFFF;opacity: 60%">水位高度:</span>
        </el-col>
        <span :key="it.pointCode" v-for="it in item.deviceMeasuringPointHistoryList">
        <el-col :span="10" style="position: relative;margin-top: 3%;margin-left: 12%;">
          <span v-if="it.pointCode == 'tm'" style="font-weight: bold;font-size: 18px;position: absolute;top: 20%" :style="{color: it.pointValue <= waterLevelAlarmHigh[index] && it.pointValue >= waterLevelAlarmLow[index] ? '#00D488' : '#F95453'}">{{it.pointValue}}{{it.pointUnit}}</span>
        </el-col>
        </span>
      </el-row>
          </div>
      </span>
    </div>

  </div>
</template>

<script>
import NoData from "@/components/NoData";
import {getHistoryBySpacePoint} from "@/network/measuring-point-history";
import {listByDeviceId} from "@/network/device-measuring-point";

export default {
  name: "WaterLevel",
  components: {NoData},
  props: {
    spaceId: {
      type: String,
      default: () => null
    }
  },
  watch: {
    spaceId() {
      this.data = []
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      data: [],
      video: [],
      typeList: ["PM_SW"],
      pointCodes: [],
      value:'0',
      dataList:[],
      waterLevelAlarmHigh:[],
      waterLevelAlarmLow:[],
      waterLevelCode:'tm'
    }
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getWaterLevel:5000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getWaterLevel')
  },
  methods: {
    getData() {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.data = []
            res.data.forEach(item => {
              item.deviceInfoList.forEach(deviceInfo => {
                listByDeviceId(deviceInfo.id).then(result => {
                  if(result.code === 0){
                    if (result.data.length > 0) {
                      result.data.forEach(it =>{
                        if(it.code === this.waterLevelCode){
                          // this.waterLevelAlarmHigh=it.alarmHigh
                          this.waterLevelAlarmHigh.push(it.alarmHigh)
                          this.waterLevelAlarmLow.push(it.alarmLow)
                        }
                      })
                    }
                  }
                })
                this.data.push(deviceInfo);
              })
            })
          }
        }
      })
    },
    change() {

    }
  }
}
</script>

<style scoped>

</style>
